import React, { useEffect } from "react";
import { Result } from "antd";
import Spin from "Components/Spinner";
import { useTranslation } from "react-i18next";
//import image from "assets/images/account_suspended.png";
const AccountSuspended = ({ productId }) => {
  const { t } = useTranslation();
  // REDIRECT TO MARKETPLACE
  useEffect(() => {
    if (productId) {
      const marketplaceUrl = process.env.REACT_APP_MARKETPLACE_URL || "http://localhost:4002";
      window.location.href = `${marketplaceUrl}/product/${productId?.toLowerCase()}--from-checkout`;
    }
  }, []);

  if (productId) {
    return <Spin size="large" style={{ display: "flex", justifyContent: "center", paddingTop: 25 }} />;
  }

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", paddingTop: 25 }}>
        <img className="img-fluid" src={"/img/logo-white.png"} alt="" />
      </div>
      <Result
        // icon={<img style={{ width: "80%", maxWidth: "250px" }} src={image} alt="unhappy" />}
        title={t("accountSuspended.title")}
        subTitle={t("accountSuspended.subTitle")}
      />
    </>
  );
};

export default AccountSuspended;
